<template>
  <div>
    <tr>
      <td>
        <div class="col-md" id="type">
          <div class="row">
            <div class="col-lg">
              <base-input label="Cluster:">
                <el-select
                  class="select-primary"
                  placeholder="Choose..."
                  size="large"
                  v-model="selects.multi"
                  @change="getRunningHolidays(selects.multi)"
                >
                  <el-option
                    style="color: #000000"
                    v-for="option in selects.multicast"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-lg">
              <base-button
                type="success"
                round
                @click.native="modals.add = true"
                :disabled="disableButton"
              >
                <i class="tim-icons icon-simple-add"></i>Add Holidays
              </base-button>
              <modal
                :show.sync="modals.add"
                footer-classes="justify-content-center"
                type="notice"
              >
                <h3 slot="header" class="modal-title">
                  Add Associate Holidays Form
                </h3>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <form @submit.prevent>
                        <div class="row justify-content-center mt-12">
                          <div class="col-sm-12">
                            <div>
                              <base-input label="Holiday Name :">
                                <el-select
                                  class="select-primary mb-3 pagination-select"
                                  v-model="holidayName"
                                  placeholder="Please select..."
                                  @change="getDate(holidayName)"
                                >
                                  <el-option
                                    v-for="select in holidaysList"
                                    class="select-primary"
                                    :value="select.value"
                                    :label="select.label"
                                    :key="select.label"
                                  >
                                  </el-option>
                                </el-select>
                              </base-input>
                              <base-input
                                type="success"
                                label="Start Date :"
                                v-model="startDate"
                                placeholder="Start Date"
                                disabled
                              >
                              </base-input>
                              <base-input
                                type="success"
                                label="End Date :"
                                v-model="endDate"
                                placeholder="End Date"
                                disabled
                              >
                              </base-input>
                            </div>
                          </div>
                          <div>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click="sendAssociate()"
                              >Submit</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.add = false"
                              >Cancel</base-button
                            >
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </modal>
            </div>
          </div>
          <div class="row">
            <!-- style="color: #00f2c3" -->
            <div class="col-lg">
              <p>
                Display holidays data that are running according to the selected
                cluster.
              </p>
            </div>
          </div>
        </div>
      </td>
    </tr>

    <!-- set holidays scheduler running called from API -->
    <div class="col-lg-12 col-md" style="padding-top: 10px">
      <h3 class="card-title brightness">
        <div>
          <div
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          ></div>
          <el-table
            :data="runningHolidays"
            :header-cell-style="{
              background: 'transparent',
              border: 'transparent',
              'font-size': '14px',
              'font-weight': '400',
              'padding-bottom': '0%',
              'padding-center': '10px',
              color: 'white',
            }"
            :cell-style="{
              border: 'transparent',
              'font-size': '14px',
              'padding-center': '20px',
            }"
          >
            <el-table-column
              v-for="column in tableHolidays"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
            <el-table-column align="right" label="Remove running holiday">
              <div slot-scope="props">
                <el-tooltip content="Delete" placement="bottom" effect="light">
                  <base-button
                    class="edit btn-link"
                    type="danger"
                    size="sm"
                    icon
                    @click="deleteAssociateHolidays(props.$index, props.row)"
                    :disabled="disableButton"
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </h3>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option,
} from "element-ui";
import { Modal, BasePagination } from "src/components";
import { TabPane, Tabs } from "src/components";
import swal from "sweetalert2";

export default {
  components: {
    TabPane,
    Tabs,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      holidayName: "",
      holidayStartDate: "",
      holidaysList: [],
      holidaysTable: [],
      // Running holiday
      runningHolidays: [],
      startDate: "",
      endDate: "",
      cluster: "",
      multi: "",
      holiday: "",
      date: "",
      setHoliday: [],
      holidayTable: [],
      setHolidayhistoryData: [],
      holidayDisplayTable: [],
      modals: {
        addHolidays: false,
        add: false,
        holidays: false,
        edit: false,
        editweekend: false,
        editholiday: false,
      },
      disableButton: true,
      loading: false,
      tableHolidays: [
        {
          prop: "holidayName",
          label: "Holiday",
        },
        {
          prop: "startDate",
          label: "Start Date",
        },
        {
          prop: "endDate",
          label: "End Date",
        },
      ],
      selects: {
        holidayInMalaysia: [
          { value: "010120010120", label: "New Year's Day" },
          { value: "080220080220", label: "Thaipusam" },
          { value: "260120270120", label: "Chinese New Year" },
          { value: "010520010520", label: "Labour Day" },
          { value: "070520070520", label: "Wesak Day" },
          { value: "100520100520", label: "Nuzul Al-Quran" },
          { value: "240520260520", label: "Hari Raya Aidilfitri" },
          { value: "310720020820", label: "Hari Raya Haji" },
          { value: "310820310820", label: "Merdeka Day" },
          { value: "200820200820", label: "Awal Muharram" },
          { value: "060620060620", label: "Agong's Birthday" },
          { value: "160920160920", label: "Malaysia Day" },
          { value: "141120151120", label: "Deepavali" },
          { value: "291020291020", label: "Prophet Muhammad's Birthday" },
          { value: "251220251220", label: "Christmas Day" },
        ],
        multi: "",
        multicast: [],
        multicastid: [],
        device: "",
        devices: [],
        scheType: "multicast",
        // schedulerType: [
        //   { value: "multicast", label: "Cluster" }
        // ],
        hour: "",
        hours: [
          { value: 1, label: "1 a.m." },
          { value: 2, label: "2 a.m." },
          { value: 3, label: "3 a.m." },
          { value: 4, label: "4 a.m." },
          { value: 5, label: "5 a.m." },
          { value: 6, label: "6 a.m." },
          { value: 7, label: "7 a.m." },
          { value: 8, label: "8 a.m." },
          { value: 9, label: "9 a.m." },
          { value: 10, label: "10 a.m." },
          { value: 11, label: "11 a.m." },
          { value: 12, label: "12 p.m." },
          { value: 13, label: "1 p.m." },
          { value: 14, label: "2 p.m." },
          { value: 15, label: "3 p.m." },
          { value: 16, label: "4 p.m." },
          { value: 17, label: "5 p.m." },
          { value: 18, label: "6 p.m." },
          { value: 19, label: "7 p.m." },
          { value: 20, label: "8 p.m." },
          { value: 21, label: "9 p.m." },
          { value: 22, label: "10 p.m." },
          { value: 23, label: "11 p.m." },
          { value: 0, label: "12 a.m." },
        ],
        min: "",
        mins: [
          { value: "0", label: "00" },
          { value: 5, label: "05" },
          { value: 10, label: "10" },
          { value: 15, label: "15" },
          { value: 20, label: "20" },
          { value: 25, label: "25" },
          { value: 30, label: "30" },
          { value: 35, label: "35" },
          { value: 40, label: "40" },
          { value: 45, label: "45" },
          { value: 50, label: "50" },
          { value: 55, label: "55" },
        ],
        status: [
          { value: "On", label: "On" },
          { value: "Off", label: "Off" },
        ],
        br: [
          { value: 10, label: "10" },
          { value: 20, label: "20" },
          { value: 30, label: "30" },
          { value: 40, label: "40" },
          { value: 50, label: "50" },
          { value: 60, label: "60" },
          { value: 70, label: "70" },
          { value: 80, label: "80" },
          { value: 90, label: "90" },
          { value: 100, label: "100" },
        ],
        simple: "",
        brightness: "",
        id: 0,
      },
    };
  },
  methods: {
    deleteAssociateRow(row) {


      this.$http
        .delete(":8004/api/v1/session/lights/" + row.sessionID)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          } else {
            //login OK!
           
            // compare id to delete row in runningHolidays table
          
            for (var i = 0; i < this.runningHolidays.length; i++) {
              if (row.sessionID === this.runningHolidays[i].sessionID) {
                this.runningHolidays.splice(i, 1);
              }
            }
          }
        })
        .catch((err) => {
         
        });

      this.getRunningHolidays(this.selects.multi);
    },
    deleteAssociateHolidays(index, row) {
     
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteAssociateRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.holidayName}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    sendAssociate() {
    
      let multicastid = "";
      // compare cluster id to get multicast id
      for (var i = 0; i < this.multicast.length; i++) {
     
        if (this.selects.multi === this.multicast[i].cluster_info.clusterid) {
          multicastid = this.multicast[i].cluster_info.multicastid;
        }
      }

      let payload = {
        entityid: multicastid,
        conntype: "LORA",
        holiday_list: [this.holidayName],
      };

      this.$http
        .post(":8004/api/v1/session/lights", payload)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: res.message,
            });
          } else {
            swal({
              type: "success",
              // title: "New Holiday Added! You’ve added " + this.holidayName
              title: res.message,
            });

        
            // compare holidays id to add automatically to table
            // for (var i = 0; i < this.holidaysTable.length; i++) {
         
            //   if (this.holidayName === this.holidaysTable[i].holidayID) {
            //     let displayPayload = {
            //       holidayName: this.holidaysTable[i].holidayName,
            //       sessionID: this.holidaysTable[i].sessionID,
            //       startDate: this.holidaysTable[i].startDate,
            //       endDate: this.holidaysTable[i].endDate
            //     };
           
            //     // replace value in array with updated data
            //     this.runningHolidays.push(displayPayload);
            //   }
            // }

            this.getRunningHolidays(this.selects.multi);

            this.modals.add = false;
            this.holidayName = "";
            this.startDate = "";
            this.endDate = "";
          }
        })
        .catch((err) => {
         
        });
    },
    getDate(holidayID) {
    
      for (var i = 0; i < this.holidaysTable.length; i++) {
        if (holidayID === this.holidaysTable[i].holidayID) {
          this.startDate = this.holidaysTable[i].startDate;
          this.endDate = this.holidaysTable[i].endDate;
        }
      }
    },
    getRunningHolidays(clusterID) {
   
      var multicastID = "";
      for (var i = 0; i < this.multicast.length; i++) {
        if (clusterID === this.multicast[i].cluster_info.clusterid) {
          multicastID = this.multicast[i].cluster_info.multicastid;
        }
      }
    

      const arr = [];
      this.$http
        .get(":8004/api/v1/session/lights/" + multicastID)
        .then((res) => {
        
          let data = res.message.schedule_session;
        

          for (var i = 0; i < data.length; i++) {
            let payload = {
              sessionID: data[i].sessionid,
              holidayName: data[i].holidayname,
              startDate: data[i].startdate,
              endDate: data[i].enddate,
            };
            this.runningHolidays.push(payload);
          }
        })
        .catch((err) => {
        
        });
      this.runningHolidays = [];
    },
    getHolidays() {
      // get table data for holidays list

      const arr = [];
      this.$http
        .get(":8004/api/v1/holidays")
        .then((res) => {
         

          var holidaySelection = res.message.holiday_list;
        

          for (var i = 0; i < holidaySelection.length; i++) {
            let payload = {
              value: holidaySelection[i].HolidayID,
              label: holidaySelection[i].holidayname,
            };

            let payloadTable = {
              holidayName: holidaySelection[i].holidayname,
              holidayID: holidaySelection[i].HolidayID,
              startDate: holidaySelection[i].startdate,
              endDate: holidaySelection[i].enddate,
            };

          
            this.holidaysTable.push(payloadTable);
            this.holidaysList.push(payload);
          }
        
        })
        .catch((err) => {
       
        });
    },
    getlist() {
      // get list of clusters
      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
           
          } else {
            let data = res.message.cluster_list;
         
            this.multicast = data;
         
            // if array empty, promp error and redirect to create cluster page
            if (this.multicast.length < 1) {
              swal({
                title: "Cluster empty",
                text: "Please create cluster to continue!",
                type: "warning",
                confirmButtonText: "OK",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              }).then(() => {
                this.$router.push("/admin/clustermanagement");
              });
            }

          
            this.selects.multicast = [];
            for (let i = 0; i < this.multicast.length; i++) {
              let multicast_array = {
                value: this.multicast[i].cluster_info.clusterid,
                label: this.multicast[i].cluster_info.clustername,
              };
              let data = {
                id: this.multicast[i].cluster_info.clusterid,
                multiid: this.multicast[i].cluster_info.multicastid,
              };
              this.selects.multicastid.push(data);
          
              this.selects.multicast.push(multicast_array);
            }

            // assign default value to table
            this.selects.multi = this.multicast[0].cluster_info.clusterid;

            this.getRunningHolidays(this.selects.multi);
          }
        })
        .catch((err) => {
        
        });
    },
  },
  computed: {},
  created() {
    
    this.getHolidays();
    this.getlist();

  },
  mounted() {
    let roleSession = JSON.parse(sessionStorage.getItem("accessList"));

   
    for (var i = 0; i < roleSession.length; i++) {
    
      if (roleSession[i] === "cluster.update") {
      
        this.disableButton = true;
        // this.disabledButton = true;
      }
      if (roleSession[i] === "admin.view") {
        this.disableButton = false;
      }
      if (roleSession[i] === "cluster.update") {
        this.disableButton = false;
      }
    }
  },
};
</script>
